import React, { Component } from "react";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import axios from "axios";
import { Modal, Image, Button } from "react-bootstrap";
// import classnames from "classnames";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import {
  BackLogoIconButton,
  LoginTopLogoAndText,
} from "../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { BottomTextAndLink } from "../../reusableComponents/smallReusableComponent/BottomTextAndLink";
import { SliderReusableComponent } from "../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import {
  // InputBoxComponent,
  NewInputText,
  PasswordReusableInput,
} from "../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import InputNumberFunc from "../../../function/InputNumberFunc";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  user_login,
  logOutUser,
  get_new_subscription_for_vendor,
} from "../../../store/actions/authAction";
import {
  LoginValidation,
  LoginEmailValidation,
} from "../../../store/validation/allValidationFile/authenticationValidation/LoginValidation";
import isEmpty from "../../../store/validation/is-Empty";
import SocketContext from "./../../../function/SocketContext";
import store from "../../../store/store";
import { SET_FORGOT_MOBILE } from "../../../store/types";
import { get_category_menu_setup_without_loader } from "../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";

import { serverApi } from "../../../config/Keys";

import feathers from "@feathersjs/client";
import socketio from "@feathersjs/socketio-client";

import authentication from "@feathersjs/client/authentication";
import { setAuthenticationToken } from "../../../api/apiHelper";

// import { CountryCodeModel } from "../../reusableComponents/allPopupReusable/countryCode/CountryCodeModel";

const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

const pageMap = {
  0: "/mapsetup",
  1: "/map-setup-two",
  2: "/restaurantsettings",
  3: "/pointofcontacts",
  4: "/restaurantinfo",
  5: "/restaurantchains",
  6: "/restauranttype",
  7: "/paymenttype",
  8: "/parking",
  9: "/petsallowed",
  10: "/dresscodetype",
  11: "accessibility",
  12: "/othresfeatures",
  13: "/serviceoffered",
  14: "/locatedinside",
  15: "/pointofsale",
  16: "/healthsenitation",
  17: "/cuisinesetup",
  18: "/foodtype",
  19: "/multicuisine",
  20: "/businesshours",
  21: "/bankdetailshome",
  22: "/subscription",
};

const pageMapTwo = {
  21: "/subscription",
};

export class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // openCountry: false,
      openBlockedModel: false,
      openOnHoldModel: false,
      openModel: false,
      displayInput: false,
      country_code: "",
      number: "",
      email: "",
      password: "",
      strategy: "",
      view: false,
      passwordIcon: true,
      slashEyeIcon: false,
      errors: {},
      error: null,
      isLoading: false,
      loading: false,
      hasSetUpdate: false,
      pathName: {},
    };
  }

  componentDidMount() {
    let host = window.location.host;
    if (host.includes("admin")) {
      this.props.history.push("/admin-login");
    }
    this.setState({ isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        this.setState({
          country_code: result.data.country_calling_code,
          isLoading: false,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );
    this.props.clear_all_errors();
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      Object.keys(nextProps.errors).length > 0 &&
      nextProps.errors !== nextState.errors
    ) {
      return {
        errors: nextProps.errors,
      };
    }
    if (nextProps.auth.loader !== nextState.loading) {
      return {
        loading: nextProps.auth.loader,
      };
    }
    if (nextProps.auth.isAuthenticated) {
      if (
        nextProps.auth.user.VendorUser.blocked &&
        nextProps.auth.user.VendorUser.blocked.isBlocked === true &&
        nextProps.auth.user.VendorUser.role === "vendor"
      ) {
        return {
          openBlockedModel:
            nextProps.auth.user.VendorUser.blocked &&
            nextProps.auth.user.VendorUser.blocked.isBlocked === true
              ? true
              : false,
        };
      } else {
        if (
          nextProps.auth.user.VendorUser &&
          nextProps.auth.user.VendorUser.onHold === true &&
          nextProps.auth.user.VendorUser.role === "vendor"
        ) {
          return {
            openOnHoldModel:
              nextProps.auth.user.VendorUser &&
              nextProps.auth.user.VendorUser.onHold === true
                ? true
                : false,
          };
        } else {
          if (
            nextProps.auth.user.VendorUser.has_admin_approved === false &&
            nextProps.auth.user.VendorUser.have_submited_details_yourself ===
              true &&
            nextProps.auth.user.VendorUser.role === "vendor" &&
            !isEmpty(nextProps.onboarding)
          ) {
            return {
              openModel:
                nextProps.auth.user.VendorUser.has_admin_approved === false &&
                nextProps.auth.user.VendorUser
                  .have_submited_details_yourself === true
                  ? true
                  : false,
            };
          } else if (
            nextProps.auth.user.VendorUser.has_admin_approved === false &&
            nextProps.auth.user.VendorUser.have_vendor_submitted_details ===
              false &&
            nextProps.auth.user.VendorUser.role === "vendor" &&
            !isEmpty(nextProps.onboarding)
          ) {
            nextProps.history.push(
              pageMap[nextProps.onboarding.page_completed_till]
            );
          } else if (
            nextProps.auth.user.VendorUser.has_admin_approved === true &&
            nextProps.auth.user.VendorUser.have_vendor_submitted_details ===
              true &&
            nextProps.auth.user.VendorUser.role === "vendor"
          ) {
            if (nextProps?.auth?.user?.VendorUser?.subscription?.ordering) {
              nextProps.history.push("/orderdashboard/10");
            } else if (
              nextProps?.auth?.user?.VendorUser?.subscription?.seating
            ) {
              nextProps.history.push("/seatingdashboard");
            } else if (nextProps?.auth?.user?.VendorUser?.subscription?.event) {
              nextProps.history.push("/event");
            } else {
              nextProps.history.push("/customerbusiness");
            }
            // if (
            //   nextState.pathName !== null &&
            //   nextState.pathName !== undefined
            // ) {
            //   return {
            //     hasSetUpdate: false,
            //   };
            // }
          } else if (
            nextProps.auth.user.VendorUser.has_admin_approved === true &&
            nextProps.auth.user.VendorUser.have_vendor_submitted_details ===
              true &&
            nextProps.auth.user.VendorUser.role === "superadmin"
          ) {
            nextProps.history.push("/superadmindashboard");
          }
        }
      }
    }
    return null;
  }

  // componentDidUpdate(prevProps) {
  //   if (
  //     prevProps?.auth?.user?.VendorUser?._id !==
  //       this.props?.auth?.user?.VendorUser?._id &&
  //     this.props?.auth?.user?.VendorUser?.has_admin_approved === true &&
  //     this.props?.auth?.user?.VendorUser?.have_vendor_submitted_details === true
  //   ) {
  //     if (
  //       prevProps.subscription !== this.state.pathname &&
  //       !this.state.hasSetUpdate
  //     ) {
  //       let formData = {
  //         vendor_id: this.props?.auth?.user?.VendorUser?._id,
  //       };
  //       this.props.get_new_subscription_for_vendor(formData, (e) =>
  //         this.onSuccessSubscription(e)
  //       );
  //       this.setState({
  //         pathname: this.props.subscription,
  //         hasSetUpdate: true,
  //       });
  //     }
  //   }
  //   return null;
  // }

  // onSuccessSubscription = (data) => {
  //   if (this.props?.subscription?.ordering?.value) {
  //     this.props.history.push("/orderdashboard/10");
  //   } else if (this.props?.subscription?.seating?.value) {
  //     this.props.history.push("/seatingdashboard");
  //   } else if (this.props?.subscription?.event_management?.value) {
  //     this.props.history.push("/event");
  //   } else {
  //     this.props.history.push("/customerbusiness");
  //   }
  // };

  handleCloseSuccess = (e) => {
    this.props.logOutUser();
    window.location.reload();
  };

  handleSubscriptionCheck = (e) => {
    this.setState({
      openModel: false,
    });
    this.props.history.push("/subscriptiondescription");
  };

  handleChangeField = (e) => {
    this.setState({
      displayInput: !this.state.displayInput,
      errors: {},
    });
  };

  /*********************************
   * @DESC Open CountryCodeModel
   ********************************/
  onOpenModal = () => {
    this.setState({ openCountry: true });
  };

  onCloseModal = () => {
    this.setState({ openCountry: false });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleOnChange = (value) => {
    this.setState({ country_code: "+" + value, errors: {} });
  };

  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
    });
    this.props.clear_all_errors();
    // this.props.clear_all_errors();
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else if (
      e.target.name === "email" &&
      !validEmailRegex.test(e.target.value)
    ) {
      errors[e.target.name] = `A valid email is required!`;
    } else if (e.target.name === "password" && e.target.value.length < 6) {
      errors[e.target.name] = `Please enter a valid password`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
    store.dispatch({
      type: SET_FORGOT_MOBILE,
      payload: this.state.number,
    });
  };

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "email":
        errors.email = validEmailRegex.test(value)
          ? ""
          : "Enter Valid Email Address";
        break;
      case "password":
        errors.password =
          value.length < 6 ? "Password must contain atleast 6 characters" : "";
        break;
      case "confirm_password":
        errors.confirm_password =
          value.length < 6
            ? "Confirm password must contain atleast 6 characters"
            : "";
        break;
      default:
        break;
    }

    this.setState({ errors, [name]: value });
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleClickShowPassword = (e) => {
    this.setState({
      view: !this.state.view,
    });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  onPasswordChange = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: false,
      slashEyeIcon: true,
    });
  };

  onPasswordHide = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: true,
      slashEyeIcon: false,
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  handleSubmit = (e) => {
    const { displayInput } = this.state;
    e.preventDefault();
    if (displayInput === false) {
      const { errors, isValid } = LoginValidation(this.state);
      if (!isValid) {
        this.setState({
          errors: errors,
        });
      } else {
        const formData = {
          mobile_number: this.state.number,
          password: this.state.password,
          country_code: this.state.country_code,
          strategy: "phone",
          country_code: this.state.country_code,
        };
        this.props.user_login(formData, (e) => this.onCallBack(e));
      }
    } else if (displayInput === true) {
      const { errors, isValid } = LoginEmailValidation(this.state);
      if (!isValid) {
        this.setState({
          errors: errors,
        });
      } else {
        const formData = {
          email: this.state.email,
          password: this.state.password,
          strategy: "local",
        };
        this.props.user_login(formData, (e) => this.onCallBack(e));
      }
    }
  };

  onCallBack = (data) => {
    this.props.socket.authentication.removeAccessToken();
    this.props.socket.authentication
      .setAccessToken(data)
      .then((res) => {
        setAuthenticationToken(data);
        this.props.socket.authentication
          .reAuthenticate()
          .then((r) => {
            console.log("Socket Reauthenticate :>> ", r);
          })
          .catch((e) => {
            console.log("error", e);
          });
      })
      .catch((err) => {
        console.log(err);
      });

    // this.props.get_category_menu_setup_without_loader(data);

    // this.props.socket
    //   .service("vendorauthentication")
    //   .create({
    //     mobile_number: data.mobile_number,
    //     password: data.password,
    //     strategy: data.strategy,
    //   })
    //   .then(function (result) {
    //     const feathersToken = result;
    //     // SET Data to Local Storage
    //     localStorage.setItem("feathersToken", JSON.stringify(feathersToken));
    //   })
    //   .catch(function (error) {
    //     console.error("Error authenticating!", error);
    //   });
  };

  renderPhoneNumberField = () => {
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-3 pr-0">
            <Form.Group
              className="reusableInputComponent-main mb-0"
              controlId={"country_code"}
            >
              <div className="input-phone-country-code-reusable w-100">
                <select
                  className="w-100"
                  name="country_code"
                  value={this.state.country_code}
                  onChange={this.onChange}
                >
                  <option value={this.state.country_code}>
                    {this.state.country_code}
                  </option>
                  {getCountries().map(
                    (country) => (
                      // this.state.country_code !==
                      // "+" + getCountryCallingCode(country) && (
                      <option
                        key={country}
                        value={"+" + getCountryCallingCode(country)}
                      >
                        {en[country]} (+{getCountryCallingCode(country)})
                      </option>
                    )
                    // )
                  )}
                </select>
              </div>
            </Form.Group>
          </div>
          <div className="col-9">
            <NewInputText
              extraClass="mb-0"
              name="number"
              inputType="number"
              onFocusOut={this.onFocusOut}
              onChange={this.onChange}
              onKeyDown={InputNumberFunc}
              autoFocus={true}
              value={this.state.number}
              maxLength="10"
              errorText={
                this.state.number.length > 0 && this.state.number.length <= 9
                  ? "Enter valid Mobile Number"
                  : null || errors.number === "number is required"
                  ? "mobile number is required"
                  : null
              }
              errorTrue={
                (this.state.number.length > 0 &&
                  this.state.number.length <= 9) ||
                errors.number === "number is required"
                  ? true
                  : false
              }
              labelText="Phone Number"
              controlClass={
                (this.state.number.length > 0 &&
                  this.state.number.length <= 9) ||
                errors.number === "number is required"
                  ? "outlined-error-helper-text"
                  : "outlined-helperText"
              }
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  renderEmailField = () => {
    const { errors, email } = this.state;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-12 mt-1">
            <NewInputText
              extraClass="mb-0"
              name="email"
              inputType="email"
              onFocusOut={this.onFocusOut}
              onChange={this.handleChange}
              value={this.state.email}
              errorText={
                !validEmailRegex.test(email) && !isEmpty(email)
                  ? "Please enter a valid email"
                  : null || errors.email === "email is required"
                  ? "email is required"
                  : ""
              }
              errorTrue={
                (!validEmailRegex.test(email) && !isEmpty(email)) ||
                errors.email === "email is required"
                  ? true
                  : false
              }
              labelText="E-mail Address"
              controlClass={
                (!validEmailRegex.test(email) && !isEmpty(email)) ||
                errors.email === "email is required"
                  ? "outlined-error-helper-text"
                  : "outlined-helperText"
              }
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { loading, errors, number, password, displayInput, email } =
      this.state;
    if (loading) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <Container fluid className="loginsignup-main">
          <Row>
            <Col className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 loginsignup-leftside">
              <div className="col-12 display-top-header-mobile display-in-mobile">
                <div className="top-back-button-logo justify-content-end">
                  <BottomTextAndLink
                    textCss="login-bottom-text-red display-bottom-signup-login mt-3"
                    text="Not having  an account?"
                    linkText="Sign Up"
                    link="/signup"
                    linkTextColor={true}
                  />
                </div>
                {/* <BackLogoIconButton
                  workWithLinkORClick={true}
                  displayHelpImage={true}
                  notDisplaProgressBar={true}
                /> */}
              </div>
              <div className="col-12 loginsignup-section">
                <LoginTopLogoAndText
                  bigText="Welcome aboard"
                  smallText="Please login to continue"
                  linkTextBig="Not having an account?"
                  linkSmall="Sign Up"
                  redirectLink="/signup"
                />
              </div>
              <Col className="login-section-margin">
                <div className="phone-email-section">
                  <button
                    className={
                      displayInput === false
                        ? "simple_button active_button"
                        : "simple_button"
                    }
                    onClick={this.handleChangeField}
                  >
                    <i className="fa fa-mobile" aria-hidden="true"></i> Login
                    with Phone Number
                  </button>
                  <button
                    className={
                      displayInput === true
                        ? "simple_button active_button"
                        : "simple_button"
                    }
                    onClick={this.handleChangeField}
                  >
                    <i className="fa fa-envelope-o" aria-hidden="true"></i>{" "}
                    Login with Email
                  </button>
                </div>
                <Form noValidate onSubmit={this.handleSubmit}>
                  {displayInput === false
                    ? this.renderPhoneNumberField()
                    : this.renderEmailField()}
                  <PasswordReusableInput
                    extraClass="mt-4 w-100"
                    labelText="Password"
                    inputTypeState={this.state.view}
                    value={this.state.password}
                    name="password"
                    onFocusOut={this.onFocusOut}
                    handleChange={this.handleChange}
                    handleClickShowPassword={this.handleClickShowPassword}
                    handleMouseDownPassword={this.handleMouseDownPassword}
                    errorText={
                      errors.code === 401
                        ? "Invalid Username or Password"
                        : errors.code === 403
                        ? errors.message
                        : errors.password
                    }
                    errorTrue={
                      errors.code === 401 ||
                      errors.code === 403 ||
                      errors.password === "password is required"
                        ? true
                        : false
                    }
                    wLabel={80}
                  />
                  <BottomTextAndLink
                    textCss="login-bottom-text mb-5"
                    linkText="Forgot password?"
                    link="/forgotpassword"
                    linkTextColor={false}
                  />
                  <ButtonReusableComponent
                    buttonText="Log In"
                    buttonType="Submit"
                    buttonClass={
                      displayInput === false
                        ? number.length <= 9 || password.length < 1
                          ? "login"
                          : "activeLogin"
                        : null || displayInput === true
                        ? email === "" ||
                          (!validEmailRegex.test(email) && !isEmpty(email))
                          ? "login"
                          : "activeLogin"
                        : null
                    }
                    disabled={
                      displayInput === false
                        ? number.length <= 9 || password.length < 1
                          ? true
                          : false
                        : null || displayInput === true
                        ? email === "" ||
                          (!validEmailRegex.test(email) && !isEmpty(email))
                          ? true
                          : false
                        : null
                    }
                  />
                </Form>
                <BottomTextAndLink
                  textCss="login-bottom-text-red display-bottom-help-text mt-3"
                  text="Need"
                  linkText="Help?"
                  link="/help"
                  linkTextColor={true}
                />
              </Col>
            </Col>
            <Col className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={
                  require("../../../assets/images/illustratorImage/Amealio_Illustrations-09.png")
                    .default
                }
              />
            </Col>
            <BlockedApproval
              state={this.state}
              handleCloseSuccess={this.handleCloseSuccess}
            />
            <OnHoldApproval
              state={this.state}
              handleCloseSuccess={this.handleCloseSuccess}
            />
            <PendingApproval
              state={this.state}
              handleCloseSuccess={this.handleCloseSuccess}
              subscriptionCheck={this.handleSubscriptionCheck}
            />
          </Row>
        </Container>
        {/* <ParticlesBg color="#636466" num={175} type="cobweb" bg={true} /> */}
      </React.Fragment>
    );
  }
}

LoginScreen.propTypes = {
  user_login: PropTypes.func.isRequired,
  get_new_subscription_for_vendor: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  subscription: state?.onboarding?.onboard_subscription_details?.casual_dining
    ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
    : state?.onboarding?.onboard_subscription_details?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status
    : {},
});

const Login = (props) => (
  <SocketContext.Consumer>
    {(socket) => <LoginScreen {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default connect(mapStateToProps, {
  user_login,
  get_new_subscription_for_vendor,
  clear_all_errors,
  logOutUser,
  get_category_menu_setup_without_loader,
})(withRouter(Login));

// /* <meta http-equiv="cache-control" content="no-cache" />
//     <meta http-equiv="expires" content="0" />
//     <meta http-equiv="pragma" content="no-cache" /> */
//

const PendingApproval = ({ state, handleCloseSuccess, subscriptionCheck }) => {
  return (
    <React.Fragment>
      <Modal show={state.openModel} onHide={handleCloseSuccess} centered>
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="text-center">
          <Image
            className="w-75 my-4"
            src={require("../../../assets/images/UserManagement/varified.svg")}
          />
          <div
            style={{ color: "#4caf50" }}
            className="f24_700_HelveticaNeue w-75 m-auto text-center pb-4"
          >
            Your account is currently under verification
          </div>
          <div className="f18-500">
            you will be notified when it is ready for login
          </div>
          <div className="f12-400 pb-3 text-gray mt-3">
            Thank you for your patience
          </div>
          <div className="row">
            <div className="col-6">
              <Button
                variant="outline-secondary"
                className="btn-md py-2 mb-2"
                style={{ width: "90%" }}
                // onClick={(e) =>
                //   this.props.history.push("/subscriptiondescription")
                // }
                onClick={handleCloseSuccess}
              >
                Come Back Later
              </Button>
            </div>
            <div className="col-6">
              <Button
                variant="danger"
                className="btn-md py-2 mb-2"
                // style={{ width: "90%" }}
                onClick={subscriptionCheck}
              >
                Continue Subscription
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const BlockedApproval = ({ state, handleCloseSuccess }) => {
  return (
    <React.Fragment>
      <Modal show={state.openBlockedModel} onHide={handleCloseSuccess} centered>
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="text-center">
          <Image
            className="w-75 my-4"
            src={require("../../../assets/images/UserManagement/varified.svg")}
          />
          <div
            style={{ color: "#EE3A23" }}
            className="f24_700_HelveticaNeue w-75 m-auto text-center pb-4"
          >
            Your Account Is Blocked
          </div>
          <div className="f18-500">
            Please Contact Amealio Support Teams{" "}
            <NavLink to="/">support@amealio.com</NavLink>
          </div>
          {/* <div className="f12-400 pb-3 text-gray mt-3">
            Thank you for your patience
          </div> */}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const OnHoldApproval = ({ state, handleCloseSuccess }) => {
  return (
    <React.Fragment>
      <Modal show={state.openOnHoldModel} onHide={handleCloseSuccess} centered>
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="text-center">
          <Image
            className="w-75 my-4"
            src={require("../../../assets/images/UserManagement/varified.svg")}
          />
          <div
            style={{ color: "#EE3A23" }}
            className="f24_700_HelveticaNeue w-75 m-auto text-center pb-4"
          >
            Your Account Is On Hold
          </div>
          <div className="f12-400 pb-3 text-gray mt-3">
            you will be notified when it is ready for login
          </div>
          <div className="f14-500">
            <NavLink to="/">support@amealio.com</NavLink>
          </div>
          {/* <div className="f12-400 pb-3 text-gray mt-3">
            Thank you for your patience
          </div> */}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
